import { render } from "./BarChart2.vue?vue&type=template&id=d25c6c16"
import script from "./BarChart2.vue?vue&type=script&lang=js"
export * from "./BarChart2.vue?vue&type=script&lang=js"

import "./BarChart2.vue?vue&type=style&index=0&id=d25c6c16&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__